// extracted by mini-css-extract-plugin
export var editButton = "_ot-0";